import { useQuery } from "@tanstack/react-query";
import { getDelegationContext } from "../../api/delegation";
import { delegationQueryKeys } from "./delegationQueryKeys";

export const useDelegationContext = (enabled = true) =>
  useQuery({
    queryKey: delegationQueryKeys.context,
    queryFn: getDelegationContext,
    enabled,
  });
